import React, { useEffect, useState, useContext } from 'react';
import { Popover } from '@headlessui/react';
import { XCircleIcon, CheckCircleIcon } from '@heroicons/react/20/solid';
import moment from "moment"
import Footer from '../../components/footer';
import { AuthContext } from '../../contexts/auth';
import { Link } from 'wouter';
import Fetching from "../../components/fetching";
import { getAlerts } from '../../services/api_dipendenti';
import Empty from '../../components/empty';
import Toggle from '../../components/toggle';
import { useLocation } from 'wouter';

export default function AvvisiComponent() {
  const { loading, token } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [alertsPage, setAlertsPage] = useState(1);
  const [alertsTotalPages, setAlertsTotalPages] = useState(1);
  const [notificationsPage, setNotificationsPage] = useState(1);
  const [notificationsTotalPages, setNotificationsTotalPages] = useState(1);
  const [selectedType, setSelectedType] = useState('Comunicazioni');
  const [location, setLocation] = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const type = queryParams.get('type');

    if (type) {
      setSelectedType(type);
    } else {
      setSelectedType('Comunicazioni');
    }
  }, [location]);


  useEffect(() => {
    if (token) {
      if (selectedType === 'Comunicazioni') {
        fetchAlerts(alertsPage);
      } else if (selectedType === 'Notifiche') {
        fetchNotifications(notificationsPage);
      }
    }
  }, [token, selectedType, alertsPage, notificationsPage]);

  const fetchAlerts = async (page) => {
    setIsLoading(true);
    setIsError(false);
    try {
      const response = await getAlerts(token, { page, page_size: 10 }, 'comunication');
      setAlerts(response.results);
      setAlertsTotalPages(Math.ceil(response.count / 10));
    } catch (error) {
      console.error('Error fetching alerts:', error);
      setIsError(true);
      Swal.fire({
        icon: 'error',
        title: 'Errore!',
        text: 'Si è verificato un errore durante il recupero delle comunicazioni.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchNotifications = async (page) => {
    setIsLoading(true);
    setIsError(false);
    try {
      const response = await getAlerts(token, { page, page_size: 10 }, 'notification');
      setNotifications(response.results);
      setNotificationsTotalPages(Math.ceil(response.count / 10));
    } catch (error) {
      console.error('Error fetching notifications:', error);
      setIsError(true);
      Swal.fire({
        icon: 'error',
        title: 'Errore!',
        text: 'Si è verificato un errore durante il recupero delle notifiche.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrevPage = () => {
    if (selectedType === 'Comunicazioni' && alertsPage > 1) {
      setAlertsPage(alertsPage - 1);
    } else if (selectedType === 'Notifiche' && notificationsPage > 1) {
      setNotificationsPage(notificationsPage - 1);
    }
  };

  const handleNextPage = () => {
    if (selectedType === 'Comunicazioni' && alertsPage < alertsTotalPages) {
      setAlertsPage(alertsPage + 1);
    } else if (selectedType === 'Notifiche' && notificationsPage < notificationsTotalPages) {
      setNotificationsPage(notificationsPage + 1);
    }
  };

  if (isLoading) {
    return <Fetching />;
  }

  return (
    <div>
      <div className="min-h-full">
        <Popover as="header" className="bg-indigo-200">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
              <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
                <div className="flex justify-center my-2 py-2">
                  <h2 className="text-center text-2xl font-semibold text-indigo-800">I miei avvisi</h2>
                </div>
              </div>
            </div>
          </div>
        </Popover>

        {isError && (
          <div className="px-4 sm:px-6 lg:px-8 mt-5">
            <p className="text-red-500">Si è verificato un errore durante il caricamento degli avvisi.</p>
          </div>
        )}

        <div className="flex justify-center mt-4 mb-0">
          <Toggle
            color="indigo"
            gradeBgColor="600"
            optionLeft="Comunicazioni"
            optionRight="Notifiche"
            selectedOption={selectedType}
            onChange={(newType) => {
              setSelectedType(newType);
              setLocation(`/areariservata/avvisi?type=${newType}`);
            }}
          />
        </div>

        {!isError && selectedType === 'Comunicazioni' && alerts.length > 0 && (
          <div className="px-4 sm:px-6 lg:px-8 mt-0">
            <div className="-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Titolo
                    </th>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Data
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Letto
                    </th>
                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {alerts.map((alert) => (
                    <tr key={alert.id}>
                      <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6">
                        <div className="font-medium text-gray-900">{alert.title}</div>
                      </td>
                      <td className="px-3 py-3.5 text-sm text-gray-500 lg:table-cell">
                        <time dateTime={alert.created_at}>{moment(alert.created_at).format('DD/MM/YYYY HH:mm')}</time>
                      </td>
                      <td className="px-3 py-3.5 text-sm text-gray-500 lg:table-cell">
                        {alert.is_read ? (
                          <CheckCircleIcon className="w-5 h-5 text-teal-500 mr-1" />
                        ) : (
                          <XCircleIcon className="w-5 h-5 text-red-500 mr-1" />
                        )}
                      </td>
                      <td className="relative py-3.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                        <Link to={`/areariservata/avvisi/${alert.id}/?type=${selectedType}`} className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
                          Leggi
                        </Link>
                        <div className="absolute -top-px left-0 right-6 h-px bg-gray-200" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="flex justify-between mt-8">
              <button 
                className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={handlePrevPage} 
                disabled={alertsPage === 1}
              >
                Precedente
              </button>
              <span className='text-sm font-medium text-gray-900'>Pagina {alertsPage} di {alertsTotalPages}</span>
              <button 
                className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={handleNextPage} 
                disabled={alertsPage === alertsTotalPages}
              >
                Successivo
              </button>
            </div>
          </div>
        )}

        {!isError && selectedType === 'Comunicazioni' && alerts.length === 0 && (<Empty />)}

        {!isError && selectedType === 'Notifiche' && notifications.length > 0 && (
          <div className="px-4 sm:px-6 lg:px-8 mt-5">
            <div className="-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Titolo
                    </th>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Data
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Letto
                    </th>
                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {notifications.map((notification) => (
                    <tr key={notification.id}>
                      <td className="relative py-4 pl-4 pr-3 text-sm sm:pl-6">
                        <div className="font-medium text-gray-900">{notification.title}</div>
                      </td>
                      <td className="px-3 py-3.5 text-sm text-gray-500 lg:table-cell">
                        <time dateTime={notification.created_at}>{moment(notification.created_at).format('DD/MM/YYYY HH:mm')}</time>
                      </td>
                      <td className="px-3 py-3.5 text-sm text-gray-500 lg:table-cell">
                        {notification.is_read ? (
                          <CheckCircleIcon className="w-5 h-5 text-teal-500 mr-1" />
                        ) : (
                          <XCircleIcon className="w-5 h-5 text-red-500 mr-1" />
                        )}
                      </td>
                      <td className="relative py-3.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                        <Link to={`/areariservata/avvisi/${notification.id}/?type=${selectedType}`} className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white">
                          Leggi
                        </Link>
                        <div className="absolute -top-px left-0 right-6 h-px bg-gray-200" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Paginazione */}
            <div className="flex justify-between mt-8">
              <button 
                className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={handlePrevPage} 
                disabled={notificationsPage === 1}
              >
                Precedente
              </button>
              <span className='text-sm font-medium text-gray-900'>Pagina {notificationsPage} di {notificationsTotalPages}</span>
              <button 
                className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={handleNextPage} 
                disabled={notificationsPage === notificationsTotalPages}
              >
                Successivo
              </button>
            </div>
          </div>
        )}
        
        {!isError && selectedType === 'Notifiche' && notifications.length === 0 && (<Empty />)}
      </div>
      <div className='pt-8'>
        <Footer />
      </div>
    </div>
  );
}